<template>
  <autocomplete
    :identifier="identifier"
    :suggestions="cities"
    :placeholder="t.placeholder"
    @select="handleSelect"
    @input="handleChange"
    :getSuggestionValue="getSuggestionValue"
    :filteredSuggestions="filteredSuggestions"
  />
</template>

<script>
import Autocomplete from "./Autocomplete";

export default {
  name: "AutocompleteCities",
  components: {
    Autocomplete,
  },
  props: {
    t: {
      type: Object,
      required: true,
    },
    cities: {
      type: Array,
      required: true,
    },
    identifier: {
      type: String,
      required: false,
      default: "autocomplete-cities",
    },
  },
  data() {
    return {
      currentValue: "",
    };
  },
  computed: {
    filteredSuggestions() {
      return [
        {
          data: this.cities.filter(city => {
            return city.name.toLowerCase().includes(this.currentValue.toLowerCase());
          }),
        },
      ];
    },
  },
  methods: {
    handleSelect(suggestion) {
      window.location.assign(suggestion.item.url);
    },
    handleChange(value) {
      this.currentValue = value;
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.name;
    },
  },
};
</script>
